import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import {
  atcClassificationsActions,
  interactionsActions,
  interactionsTypeActions,
  messageActions
} from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../utils/permissions'
import ChipInput from 'material-ui-chip-input'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import * as API from '../../api'
import TextField from '@material-ui/core/TextField'
import SelectWrapped from '../../components/SelectWrapped'
import Chip from '@material-ui/core/Chip'
import {
  formatContentSelectValueSingle,
  formatContentSelectValue,
  filterOptionsFunction
} from '../../utils'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  componentDidMount() {
    const { fetchAtcClassifications } = this.props
    fetchAtcClassifications()
  }

  handleSave = interaction => {
    const { onClose, addInteraction, editInteraction, changeMessage } = this.props
    if (interaction._id) {
      editInteraction(interaction).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addInteraction(interaction).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, interaction) => {
    e.preventDefault()
    const { setInteractionFormTouched } = this.props
    if ((this.props.interactionFormErrors || {}).valid) {
      this.handleSave(interaction)
    } else {
      setInteractionFormTouched()
    }
    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      interactionsType,
      interaction,
      handleChangeInteraction,
      loadingInteraction,
      interactionFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('interacoes', token)

    return (
      <div>
        <Dialog
          modalId={interaction._id ? 'interacoes-editar' : 'interacoes-nova'}
          modalParams={{ registro: interaction._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingInteraction ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(interaction._id ? 'interacoes-editar' : 'interacoes-nova') + '-title'}>
                {isReadOnly ? (
                  'interacoes'
                ) : (
                  <Fragment>
                    {interaction._id ? 'Editar interação' : 'Cadastrar interação'}
                  </Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'interaction-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, interaction)
                  }}
                >
                  <FormControl
                    error={
                      !((interactionFormErrors.fields || {})['interacaoTipo_id'] || {}).valid &&
                      formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <TextField
                      disabled={isReadOnly}
                      fullWidth
                      onChange={obj => {
                        handleChangeInteraction({ ...interaction, interacaoTipo_id: obj })
                      }}
                      error={
                        !((interactionFormErrors.fields || {})['interacaoTipo_id'] || {}).valid &&
                        formTouched
                      }
                      value={formatContentSelectValueSingle(interaction.interacaoTipo_id || {})}
                      placeholder="Selecione..."
                      name="react-select-chip-label"
                      label="Interação"
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{
                        inputComponent: SelectWrapped,
                        inputProps: {
                          multi: false,
                          filterOptions: filterOptionsFunction,
                          instanceId: 'react-select-chip-label',
                          id: 'react-select-chip-label',
                          loadOptions: API.interactionsType.getSelectInteractionsType,
                          disableDelete: isReadOnly
                        }
                      }}
                    />
                    {!((interactionFormErrors.fields || {})['interacaoTipo_id'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {
                          ((interactionFormErrors.fields || {})['interacaoTipo_id'] || {})
                            .errorMessage
                        }
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((interactionFormErrors.fields || {})['mdcmnts'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <TextField
                      disabled={isReadOnly}
                      fullWidth
                      onChange={obj => {
                        handleChangeInteraction({ ...interaction, mdcmnts: obj })
                      }}
                      error={
                        !((interactionFormErrors.fields || {})['mdcmnts'] || {}).valid &&
                        formTouched
                      }
                      value={formatContentSelectValue(interaction.mdcmnts || [])}
                      placeholder="Selecione..."
                      name="react-select-chip-label"
                      label="Medicamentos"
                      required={'required'}
                      htmlFor="field-mdcmnts"
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{
                        inputComponent: SelectWrapped,
                        inputProps: {
                          multi: true,
                          filterOptions: filterOptionsFunction,
                          instanceId: 'react-select-chip-label',
                          id: 'react-select-chip-label',
                          loadOptions: API.atcClassifications.getSelectAtcClassifications,
                          disableDelete: isReadOnly
                        }
                      }}
                    />
                    {!((interactionFormErrors.fields || {})['mdcmnts'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((interactionFormErrors.fields || {})['mdcmnts'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((interactionFormErrors.fields || {})['excetosMed1'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <TextField
                      disabled={isReadOnly}
                      fullWidth
                      onChange={obj => {
                        handleChangeInteraction({ ...interaction, excetosMed1: obj })
                      }}
                      error={
                        !((interactionFormErrors.fields || {})['excetosMed1'] || {}).valid &&
                        formTouched
                      }
                      value={formatContentSelectValue(interaction.excetosMed1 || [])}
                      placeholder="Selecione..."
                      name="react-select-chip-label"
                      label="Excetos Medicamento 1"
                      htmlFor="field-excetosMed1"
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{
                        inputComponent: SelectWrapped,
                        inputProps: {
                          multi: true,
                          filterOptions: filterOptionsFunction,
                          instanceId: 'react-select-chip-label',
                          id: 'react-select-chip-label',
                          loadOptions: API.atcClassifications.getSelectAtcClassifications,
                          disableDelete: isReadOnly
                        }
                      }}
                    />
                    {!((interactionFormErrors.fields || {})['excetosMed1'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((interactionFormErrors.fields || {})['excetosMed1'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((interactionFormErrors.fields || {})['excetosMed2'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <TextField
                      disabled={isReadOnly}
                      fullWidth
                      onChange={obj => {
                        handleChangeInteraction({ ...interaction, excetosMed2: obj })
                      }}
                      error={
                        !((interactionFormErrors.fields || {})['excetosMed2'] || {}).valid &&
                        formTouched
                      }
                      value={formatContentSelectValue(interaction.excetosMed2 || [])}
                      placeholder="Selecione..."
                      name="react-select-chip-label"
                      label="Excetos Medicamento 2"
                      htmlFor="field-excetosMed2"
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{
                        inputComponent: SelectWrapped,
                        inputProps: {
                          multi: true,
                          filterOptions: filterOptionsFunction,
                          instanceId: 'react-select-chip-label',
                          id: 'react-select-chip-label',
                          loadOptions: API.atcClassifications.getSelectAtcClassifications,
                          disableDelete: isReadOnly
                        }
                      }}
                    />
                    {!((interactionFormErrors.fields || {})['excetosMed2'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((interactionFormErrors.fields || {})['excetosMed2'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button
                    type={'submit'}
                    form={'interaction-form'}
                    color="primary"
                    variant="raised"
                  >
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    interaction: state.interactions.interaction,
    loadingInteraction: state.interactions.loadingInteraction,
    interactionFormErrors: state.interactions.interactionFormErrors,
    formTouched: state.interactions.interactionFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(interactionsActions.openModal())
    },
    closeModal: () => {
      dispatch(interactionsActions.closeModal())
    },
    handleChangeInteraction: interaction => {
      dispatch(interactionsActions.handleChangeInteraction(interaction))
    },
    addInteraction: interaction => {
      return dispatch(interactionsActions.addInteraction(interaction))
    },
    editInteraction: interaction => {
      return dispatch(interactionsActions.editInteraction(interaction))
    },
    setInteractionFormTouched: interaction => {
      dispatch(interactionsActions.setInteractionFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    fetchAtcClassifications: options => {
      dispatch(atcClassificationsActions.fetchAtcClassifications(options))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/Interactions/EditModal.js